
import React from 'react';
import { cn } from '@/lib/utils';
import { PaymentStatusBadge } from '@/pages/admin/payments/PaymentStatusBadge';
import { RentalStatusBadge } from '@/pages/admin/rentals/components/RentalStatusBadge';

interface StatusBadgeProps {
  status: string;
  type: 'bike' | 'rental' | 'courier' | 'payment';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type }) => {
  // Если это платеж, используем PaymentStatusBadge
  if (type === 'payment') {
    return <PaymentStatusBadge status={status} />;
  }
  
  // Если это аренда, используем RentalStatusBadge
  if (type === 'rental') {
    return <RentalStatusBadge status={status} />;
  }
  
  // Для остальных типов сохраняем прежнюю логику
  const getClasses = () => {
    if (type === 'bike') {
      switch (status) {
        case 'available':
          return 'status-available';
        case 'in_use':
          return 'status-in-use';
        case 'maintenance':
          return 'status-maintenance';
        case 'retired':
          return 'status-retired';
        default:
          return 'status-inactive';
      }
    } else if (type === 'courier') {
      switch (status) {
        case 'active':
          return 'status-available';
        case 'inactive':
          return 'status-inactive';
        default:
          return 'status-inactive';
      }
    }
    
    return 'status-inactive';
  };
  
  const getLabel = () => {
    if (type === 'bike') {
      switch (status) {
        case 'available':
          return 'Доступен';
        case 'in_use':
          return 'Используется';
        case 'maintenance':
          return 'Ремонт';
        case 'retired':
          return 'Списан';
        default:
          return status;
      }
    } else if (type === 'courier') {
      switch (status) {
        case 'active':
          return 'Активен';
        case 'inactive':
          return 'Неактивен';
        default:
          return status;
      }
    }
    
    return status;
  };

  return (
    <span className={cn('status-badge', getClasses())}>
      {getLabel()}
    </span>
  );
};
